module.exports = __webpack_public_path__ + "static/img/PW.1d4bf50f.png";